import { useCallback, useEffect, useRef, useState } from 'react'

export const useScrollDirection = (delay = 500) => {
  const [direction, setDirection] = useState('')
  const [scrollY, setScrollY] = useState(window.pageYOffset)
  const isAbleToCall = useRef(true)

  const callback = useCallback(() => {
    const currentScrollY = window.pageYOffset

    if (scrollY > currentScrollY) {
      setDirection('up')
    } else {
      setDirection('down')
    }

    setScrollY(currentScrollY)
  }, [scrollY])

  const delayedCallback = useCallback(() => {
    if (isAbleToCall.current) {
      callback()
      isAbleToCall.current = false

      setTimeout(() => {
        callback()
        isAbleToCall.current = true
      }, delay)
    }
  }, [callback, delay])

  useEffect(() => {
    document.addEventListener('scroll', delayedCallback)

    return () => {
      document.removeEventListener('scroll', delayedCallback)
    }
  }, [delayedCallback])

  return [direction, scrollY]
}
